<template>
  <div>
    <div v-for="(record, index) in editRecords" class="row block">
      <div class="col-md-2">
        <div class="created_info">
          <p>
            <UserName :id="record.user_id"/>
          </p>
          <p class="text-muted">{{ record.report_date || "сейчас" }}</p>
        </div>
      </div>
      <div class="col-md-2 form-group">
        <label for="">Валюта</label>
        <input
          type="text"
          :value="currencies[record.currency_id].currency"
          readonly
          class="form-control"
        />
      </div>
      <div class="col-md-2 form-group">
        <label for="">Количество</label>
        <input
          @keyup="updateRecord(index, 'sum')"
          :disabled="record.to_delete"
          type="text"
          v-model="record.sum"
          class="form-control"
        />
      </div>
      <div class="col-md-2 form-group">
        <label for="">Курс</label>
        <input
          @keyup="updateRecord(index, 'displayRate')"
          :disabled="record.to_delete"
          type="text"
          v-model="record.displayRate"
          class="form-control"
        />
      </div>
      <div class="col-md-2 form-group">
        <label for="">На сумму</label>
        <input
          @keyup="updateRecord(index, 'total')"
          :disabled="record.to_delete"
          type="text"
          v-model="record.total"
          class="form-control"
        />
      </div>
      <div class="col-md-2 form-group flex align-self-end justify-content-end">
        <div v-if="!disableToSaveRate">
          <label :for="`gridCheck_${index}`">
            <input class="form-check-input"
                   v-model="record.saveRate"
                   type="checkbox"
                   :id="`gridCheck_${index}`"
            />
            <span>сохранить курс</span></label>
        </div>
        <button
          @click="record.to_delete = !record.to_delete"
          class="btn btn-danger"
        >
          <i class="icon-fa icon-fa-remove"></i>
        </button>
      </div>
    </div>
    <div class="flex justify-content-between p-t-10">
      <div>
        <div class="input-group">
          <select class="custom-select" v-model="newCurrencyId">
            <option disabled value="0">Выберите валюту</option>
            <option v-for="(currency, id) in allowToBuy" :value="id">{{
                currency
              }}
            </option>
          </select>
          <div class="input-group-append">
            <button @click="addNew" class="btn btn-info">Купить</button>
          </div>
        </div>
      </div>
      <vue-ladda
        @click="save"
        button-class="btn btn-success"
        data-style="zoom-in"
        :loading="loading"
      >Сохранить валюты
      </vue-ladda>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import VueLadda from "vue-ladda/src/vue-ladda.vue";
import {diff, updatedDiff} from "deep-object-diff";
import UserName from "@/components/users/UserName.vue";

export default {
  props: [
    'disableToSaveRate',
    "currencies",
    "records",
    "date",
    "division",
    "userId",
    "updateRecords",
    "users"
  ],
  components: {
    UserName,
    VueLadda
  },
  data() {
    return {
      allowToBuy: {},
      newCurrencyId: 0,
      loading: false,
      editRecords: []
    };
  },
  watch: {
    records: {
      handler: function (val) {
        this.cloneRecords();
      }
    },
    editRecords: {
      handler: function (val, oldVal) {
        val.forEach((obj, key) => {
          const changes = diff(obj, this.records[key]);
          if (changes && Object.keys(changes).length) {
            this.editRecords[key].changed = true;
            this.records[key].changed = true;
          }
        });
        this.updateAllowToBuy();
      },
      deep: true
    }
  },
  async mounted() {
    this.updateAllowToBuy();
    this.cloneRecords();
  },
  methods: {
    updateRecord(index, field) {
      console.log(index, field);
      switch (field) {
        case "sum":
          if (this.editRecords[index].displayRate) {
            this.editRecords[index].total =
              Math.round(
                this.editRecords[index].sum *
                this.editRecords[index].displayRate *
                10000
              ) / 10000;
          }
          break;
        case "total":
          if (this.editRecords[index].displayRate) {
            this.editRecords[index].sum =
              Math.round(
                (this.editRecords[index].total /
                  this.editRecords[index].displayRate) *
                10000
              ) / 10000;
          }
          break;
        case "displayRate":
          if (this.editRecords[index].sum) {
            this.editRecords[index].total =
              Math.round(
                this.editRecords[index].sum *
                this.editRecords[index].displayRate *
                10000
              ) / 10000;
          }
          break;
      }
    },
    cloneRecords() {
      this.editRecords = [];
      if (this.records) {
        this.records.forEach(e => {
          e.total = Math.round((e.sum ? e.sum : 0) / (e.rate ? e.rate : 0));
          e.displayRate = Math.round((e.total / e.sum) * 10000) / 10000;
          this.editRecords.push({...e, to_delete: false});
        });
      }
    },
    addNew() {
      if (!this.newCurrencyId) return;
      this.editRecords.push({
        id: null,
        sum: 0,
        rate: 0,
        displayRate: 0,
        total: 0,
        report_date: this.date,
        currency_id: this.newCurrencyId,
        user_id: this.userId,
        to_delete: false,
        saveRate: false
      });
      this.newCurrencyId = 0;
      this.updateAllowToBuy();
    },
    async save() {
      if (!this.editRecords || !this.editRecords.length) return;
      this.loading = true;
      const {data} = await api.post("/reports/updateReport", {
        type: "exchange",
        records: this.editRecords,
        division: this.division,
        date: this.date
      });

      if (data.success) {
        if (this.updateRecords) {
          this.updateRecords(data.records);
        }
        toastr["success"]("Сохранено!");
      } else {
        toastr["warning"](data.message || "Ошибка!");
      }
      this.loading = false;
    },
    updateAllowToBuy() {
      const divisionCurrencyId = this.$AllDivisions[this.division]?.settings?.currency_id ?? null;
      this.allowToBuy = Object.keys(this.currencies).reduce((acc, c) => {
        if (divisionCurrencyId || this.currencies[c].id !== 33) {
          acc[this.currencies[c].id] = this.currencies[c].currency;
        }
        return acc;
      }, {});
      this.editRecords.forEach(r => {
        delete this.allowToBuy[r.currency_id];
      });
    }
  }
};
</script>

<style scoped>
@media (max-width: 576px) {
  .block {
    padding: 10px 5px !important;
    border: 1px solid lightgray;
    margin: 0 -3px;
    margin-bottom: 10px;
    background-color: #fcfafa;
  }
}

label span {
  margin-left: 17px;
}

.form-check-input {
  margin-left: 0;
}

.block .col-md-2 {
  padding: 0;
}

.row select,
.row input,
.row button {
  border-radius: 0;
}

i {
  text-align: center;
}

.row {
  padding: 2px 16px;
}

.flex p {
  font-size: 10px;
  margin-bottom: 2px;
}

.created_info {
  /* width: 125px; */
  padding-right: 5px;
}

.created_info p {
  /* text-overflow: ellipsis; */
  /* white-space: nowrap; */
  /* overflow: hidden; */
  margin-bottom: 2px;
}
</style>
